import styled, { css } from 'styled-components';
import { shade, tint } from 'polished';

interface IContainerProps {
  status: string;
}

export const Container = styled.button<IContainerProps>`
  ${({ theme, disabled, status }) => css`
    width: 150px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 1rem;
    background-color: ${status === 'success'
      ? theme.colors.green
      : status === 'error'
      ? theme.colors.danger
      : theme.colors.yellow};
    color: #fff;
    border-radius: ${theme.radius.default};
    font-size: 14px;
    font-weight: 400;

    ${disabled
      ? css`
          background-color: ${tint(
            0.3,
            status === 'success'
              ? theme.colors.green
              : status === 'error'
              ? theme.colors.danger
              : theme.colors.yellow,
          )};
          cursor: not-allowed;
        `
      : css`
          :hover {
            background: ${shade(
              0.2,
              status === 'success'
                ? theme.colors.green
                : status === 'error'
                ? theme.colors.danger
                : theme.colors.yellow,
            )};
            transition: 0.2s;
          }
        `}
  `}
`;
